import React from "react";
import { displayPct, limitDecimals } from "../../../global/utils";
import { ContractsManagerContext, FunctionsContext, StrategyContext, SystemSummaryContext } from "../../../global/contexts";
import { ISysAccountInfoObj, ISysPooledFundInfoObj } from "../../../global/types";

export function StrategyStatusSidebarElement() {
  const { contractManager } = React.useContext(ContractsManagerContext);
  const { selectedStrategy } = React.useContext(StrategyContext);
  const { SystemSummary } = React.useContext(SystemSummaryContext);
  const { tryTx } = React.useContext(FunctionsContext);

  const [cashPnl, setCashPnl] = React.useState(0);

  React.useEffect(() => {
    let _cashPnl = 0;

    if (selectedStrategy.isPooledFund && "memberBalance" in SystemSummary.currentContract) {
      _cashPnl = (SystemSummary.currentContract as ISysPooledFundInfoObj).memberBalance.pnl;
    }
    else {
      _cashPnl = (SystemSummary.currentContract as ISysAccountInfoObj).contractBalance.pnl;
    }

    setCashPnl(limitDecimals(_cashPnl / contractManager.cash.denominator.toNumber()));
  }, [selectedStrategy.isPooledFund, contractManager.cash.denominator, SystemSummary.currentContract]);

  // const daysRemaining = user?.upkeep.daysRemaining;

  let tradeStatus = "-";

  const long = SystemSummary.currentContract.tradingEngineInfo.tradeStatus[2].toUpperCase() === "F";
  const short = SystemSummary.currentContract.tradingEngineInfo.tradeStatus[3].toUpperCase() === "F";

  if (long && short) {
    tradeStatus = `${displayPct(SystemSummary.currentContract.pctPositions.pctLong, 0)}% Long ${displayPct(SystemSummary.currentContract.pctPositions.pctShort, 0)}% Short`;
  }
  else if (long) {
    tradeStatus = `${displayPct(SystemSummary.currentContract.pctPositions.pctLong, 0)}% Long`;
  }
  else if (short) {
    tradeStatus = `${displayPct(SystemSummary.currentContract.pctPositions.pctShort, 0)}% Short`;
  }
  else {
    tradeStatus = "Holding Cash";
  }

  async function cancelPendingWithdrawals() {
    const contract = selectedStrategy.isPooledFund ? contractManager.contracts.PooledFund : contractManager.contracts.DepositWithdraw;

    if (!contract.functions) {
      throw new Error("No contract functions in cancelPendingWithdrawals()!");
    }

    tryTx(contract.functions.cancelPendingWithdrawals);
  }

  return (
    <div className="etx-card Card bg-white-1-20 border-radius overflow-hidden">
      <div className="etx-card__item Card__item ph-0 pv-0">
        <div className="etx-button-list ButtonList card-header">
          <button
            className="etx-button Button fullwidth border-radius-0 has-info"
            title="See all details about your account in the Bot"
          >
            <span className="etx-button__text Button__text">
              My&nbsp;&nbsp;Account&nbsp;&nbsp;Status
            </span>
            <div className="Button__info">
              <i className="far fa-info-circle"></i>
            </div>
          </button>
        </div>
      </div>

      <div className="etx-card__item Card__item pv-50">
        <div className="etx-flex Flex c-auto av-center gh-50 gv-0">
          <div className="etx-flex__item Flex__item shrink-0">
            <div className="etx-text Text" title="While in a trade, shows your estimated cash balance. Exact PnL is shown when 'Holding Cash.'">
              <p className="font-label">{contractManager.cash.name} PnL<i className="far fa-info-circle"></i></p>
            </div>
          </div>

          {/* TODO: current pnl */}
          <div className="etx-flex__item Flex__item grow-1">
            <div className="etx-text Text a-right">
              <p className="font-size-large font-weight-medium" style={{ color: cashPnl > 0 ? "#7dff8a" : cashPnl < 0 ? "#ff7d7d" : "white" }}>
                {cashPnl}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="etx-card__item Card__item ph-0 pv-0">
        <hr />
      </div>

      <div className="etx-card__item Card__item pv-50">
        <div className="etx-flex Flex c-auto av-center gh-50 gv-0">
          <div className="etx-flex__item Flex__item shrink-0">
            <div className="etx-text Text">
              <p className="font-label">Strategy Status</p>
            </div>
          </div>

          <div className="etx-flex__item Flex__item grow-1">
            <div className="etx-text Text a-right">
              <p className="font-size-large font-weight-medium">
                {
                  long && short
                    ? <span style={{ fontSize: "0.8em" }}>{tradeStatus}</span>
                    : tradeStatus
                }
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="etx-card__item Card__item ph-0 pv-0">
        <div className="etx-button-list ButtonList">
          <button
            className="etx-button Button fullwidth border-radius-0 has-info cancelPendingTransfersColour"
            title="Cancels any pending transfers from the Bot."
            onClick={() => cancelPendingWithdrawals()}
          >
            <div className="etx-button__icon Button__icon">
              <i className="far fa-times"></i>
            </div>
            <span className="etx-button__text Button__text" style={{ fontSize: "12px" }}>Cancel Pending Withdrawals</span>
            {/* <div className="Button__info">
              <i className="far fa-info-circle"></i>
            </div> */}
          </button>
        </div>
      </div>
    </div>
  );
}
